// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-intersect-intersect-inner-khjyz{width:100%;align-items:center;display:flex;justify-content:center}.components-intersect-intersect-inner-khjyz,.components-intersect-intersect-svg-eivsv{height:100px}.components-intersect-intersect-svg-eivsv{width:100px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inner": "components-intersect-intersect-inner-khjyz",
	"svg": "components-intersect-intersect-svg-eivsv"
};
module.exports = ___CSS_LOADER_EXPORT___;
